module.exports = __webpack_public_path__ + "static/media/sign-in.fbefd9f4.png";